import React, { useState, useRef, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, ChevronDown, Check } from 'lucide-react';
import { BsTwitterX } from "react-icons/bs"; // Importing Twitter icon from react-icons
import { FaFacebookF } from 'react-icons/fa';
import comingsoon from '../../assets/image (1).png'




const handlePhoneCall = () => {
  window.location.href = "tel:+18882021350"
}

function DesktopNavbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Get current page from URL
  const getCurrentPage = () => {
    const path = window.location.pathname;
    if (path === '/' || path === '/  ') return 'Home';
    if (path === '/AboutUs') return 'About Us';
    if (path === '/ContactUs') return 'Contact Us';
    if (path === '/Services') return 'Services';

  };

  const [activePage, setActivePage] = useState(getCurrentPage());

  const handleMouseEnter = () => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      setHoverTimeout(null);
    }
    setDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setDropdownOpen(false);
    }, 150);
    setHoverTimeout(timeout);
  };

  const handleDropdownMouseEnter = () => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      setHoverTimeout(null);
    }
  };

  const handleDropdownMouseLeave = () => {
    const timeout = setTimeout(() => {
      setDropdownOpen(false);
    }, 150);
    setHoverTimeout(timeout);
  };

  useEffect(() => {
    return () => {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
      }
    };
  }, [hoverTimeout]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className="w-full bg-white shadow flex flex-wrap items-center justify-between px-4 md:px-16 lg:px-28 py-2 ">
      <div className="flex items-center mt-4">
        <Link to="/">
          <img
            src={comingsoon}
            alt="coming soon background"
            className="w-32 sm:w-40 md:w-48 h-auto"
            loading="lazy"
            sizes="(max-width: 640px) 100vw, (max-width: 768px) 100vw, (max-width: 1024px) 100vw, 100vw"
          />
        </Link>
      </div>

      {/* Call Now Button */}
      {/* <div className="mt-3 md:mt-0">
    <button
      onClick={handlePhoneCall}
      className="bg-#532200 rounded-lg px-3 py-2 sm:px-4 sm:py-2 text-white text-center shadow hover:bg-white hover:text-#532200 transition-colors duration-200 w-full sm:w-auto"
    >
      <div className="text-xs sm:text-sm md:text-base font-semibold">CALL NOW</div>
    </button>
  </div> */}
    </nav>

  );
}

function MobileNavbar() {
  const [open, setOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const getCurrentPage = () => {
    const path = window.location.pathname;
    if (path === '/' || path === '/  ') return 'Home';
    if (path === '/AboutUs') return 'About Us';
    if (path === '/ContactUs') return 'Contact Us';
    if (path === '/Services') return 'Services';
    return 'Home';
  };

  const [active, setActive] = useState(getCurrentPage());

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open && !event.target.closest('.mobile-menu')) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "unset";
    return () => (document.body.style.overflow = "unset");
  }, [open]);

  return (
    <nav className="w-full bg-white shadow px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center mt-4">
          <Link to="/">
            <img
              src={comingsoon}
              alt="coming soon background"
              className="w-32 sm:w-40 md:w-48 h-auto"
              loading="lazy"
              sizes="(max-width: 640px) 100vw, (max-width: 768px) 100vw, (max-width: 1024px) 100vw, 100vw"
            />
          </Link>
        </div>

      </div>

      <div
        className={`mobile-menu fixed inset-0 bg-white z-40 flex flex-col transition-all duration-500 ${open ? "translate-x-0 opacity-100" : "-translate-x-full opacity-0 pointer-events-none"
          }`}
      >
        <div className="flex items-center justify-between px-4 py-4 shadow-md">
          <button
            className="text-#532200 text-3xl font-bold"
            onClick={() => setOpen(false)}
          >
            &times;
          </button>
          <h3 className="font-bold text-xl">Erexcel</h3>
          <span></span>
        </div>

        <div className="flex-1 bg-[#E7E9F4] overflow-y-auto">
          <ul className="flex flex-col p-6 space-y-4">
            <li>
              <Link
                to="/"
                onClick={() => setOpen(false)}
                className={`block p-2 rounded ${active === "Home" && "bg-white font-bold text-#532200"
                  }`}
              >
                Home
              </Link>
            </li>

            <li>
              <Link
                to="/AboutUs"
                onClick={() => setOpen(false)}
                className={`block p-2 rounded ${active === "About Us" && "bg-white font-bold text-#532200"
                  }`}
              >
                About Us
              </Link>
            </li>

            <li>
              <button
                onClick={() => setServicesOpen(!servicesOpen)}
                className={`flex justify-between w-full p-2 rounded ${active === "Services" && "bg-white font-bold text-#532200"
                  }`}
              >
                Services
                <ChevronDown
                  className={`transition-transform ${servicesOpen ? "rotate-180" : ""}`}
                />
              </button>
            </li>

            <li>
              <Link
                to="/ContactUs"
                onClick={() => setOpen(false)}
                className={`block p-2 rounded ${active === "Contact Us" && "bg-white font-bold text-#532200"
                  }`}
              >
                Contact Us
              </Link>
            </li>
          </ul>

          <div className="mt-10 px-8 pb-8 bg-#532200">
            <h3 className="text-white font-semibold text-lg mb-4">Follow Us</h3>
            <div className="flex gap-6">
              {[FaFacebookF, BsTwitterX, Instagram, Linkedin].map((Icon, idx) => (
                <Icon
                  key={idx}
                  className="w-6 h-6 text-white cursor-pointer hover:scale-110 transition"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}


const Navbar = () => {
  return (
    <header>
      <div className="hidden md:block">
        <DesktopNavbar />
      </div>
      <div className="block md:hidden">
        <MobileNavbar />
      </div>
    </header>
  );
};

export default Navbar;











